import { Stack, styled } from "@mui/material";

export const FieldWrapper = styled(Stack)`
  gap: 0.25rem;
`;
